export default __webpack_public_path__ + "static/media/transparent.6f5a27b7.svg";